import { UPDATE_LOADER_STATE} from '../types';
export const updateLoaderState =(isLoading=false)=>{
    return {
        type : UPDATE_LOADER_STATE,
        isLoading : isLoading
    }
}
